import React from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { websiteBuilderPostMediaItem } from "redux/actions/websiteBuilder/editor/websiteBuilderEditor";
import { TWebsiteBuilderFileDropZoneTheme, TWebsiteBuilderFileType, WebsiteBuilderFileDropZone } from "pages/secure/facility/websiteBuilder/shared/components/fileDropZone/WebsiteBuilderFileDropZone";
import { WEBSITE_BUILDER_IMAGE_ALLOWED_FILE_TYPES, WEBSITE_BUILDER_VIDEO_ALLOWED_FILE_TYPES } from "../../utility/websiteBuilderAllowedMedia";

interface IWebsiteBuilderMediaDropZoneProps {
  theme: TWebsiteBuilderFileDropZoneTheme;
  condensed?: boolean;
  allowImages?: boolean;
  allowVideos?: boolean;
}

export function WebsiteBuilderMediaDropZone(props: IWebsiteBuilderMediaDropZoneProps) {
  const {
    theme,
    condensed,
    allowImages,
    allowVideos,
  } = props;

  const dispatch = useAppDispatch();

  const { t } = useTranslation();

  const websiteId = useAppSelector(store => store.websiteBuilderStore.config.website?.id);

  const allowedFileTypes: TWebsiteBuilderFileType[] = [
    ...(allowImages ? WEBSITE_BUILDER_IMAGE_ALLOWED_FILE_TYPES : []),
    ...(allowVideos ? WEBSITE_BUILDER_VIDEO_ALLOWED_FILE_TYPES : []),
  ];

  function saveMedia(file: File) {
    void dispatch(websiteBuilderPostMediaItem(websiteId, file, t));
  }

  return (
    <WebsiteBuilderFileDropZone
      theme={theme}
      condensed={condensed}
      allowedFileTypes={allowedFileTypes}
      maxImageMegabytes={10}
      maxVideoMegabytes={25}
      saveFile={saveMedia}
    />
  );
}
